import { F } from '@/utils/intl';
import React from 'react';
import { useIntl } from 'umi';
import ProForm, { ProFormDigit, ProFormText } from '@ant-design/pro-form';
import { Col, Form, Row, Space } from 'antd';
import InfoCard from '@/components/ProjectDetails/Cards/InfoCard';
import { SnippetsOutlined } from '@ant-design/icons';
import LeadStateFilters from '@/components/Filters/LeadStateFilters';
import LeadAssigneeDropdownFilters from '@/components/Filters/LeadAssigneeDropdownFilters';
import ProductGroupSelect from '@/components/Filters/ProductGroupSelect';
import { FormInstance } from 'antd/lib/form';
import styles from './index.less';
import ExtraFields from '@/components/LeadSource/ManualLead/ExtraFields';

interface ProjectFormProps {
  form: FormInstance;
  onProjectExtraFieldValuesChange: (values: any) => void;
}

const ProjectForm: React.FC<ProjectFormProps> = ({
  form,
  onProjectExtraFieldValuesChange,
}) => {
  const intl = useIntl();

  return (
    <InfoCard
      title={
        <Space>
          <SnippetsOutlined />
          <F
            id={'pages.lead.project_information'}
            defaultMessage={'Project Information'}
          />
        </Space>
      }
      variant="purple"
      className={styles.infoCardSection}
    >
      <ProForm
        form={form}
        autoComplete="off"
        size="small"
        submitter={false}
        variant="underlined"
      >
        <Row gutter={16}>
          <Col span={24}>
            <ProFormText
              label={intl.formatMessage({
                id: 'common.attribute.title',
                defaultMessage: 'Title',
              })}
              name="title"
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <F
                  id={'pages.leadsources.manual.chooseStatus'}
                  defaultMessage={'Choose status'}
                />
              }
              name="lead_state_id"
            >
              <LeadStateFilters
                type="dropdown"
                filterMode={'select'}
                selectProps={{
                  variant: 'underlined',
                  allowClear: false,
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={intl.formatMessage({
                id: 'pages.leadsources.assignedTo',
                defaultMessage: 'Assign to',
              })}
              name="assignee_id"
            >
              <LeadAssigneeDropdownFilters
                type="dropdown"
                onlyAssignable
                hideDisabled
                defaultMe
                filterMode={'select'}
                selectProps={{
                  variant: 'underlined',
                  allowClear: true,
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <ProForm.Item
              label={
                <F
                  id="entity.product_group.singular"
                  defaultMessage="Product Group"
                />
              }
              name="product_group_id"
            >
              <ProductGroupSelect
                filterMode={'select'}
                hasCreate
                selectProps={{
                  variant: 'underlined',
                }}
              />
            </ProForm.Item>
          </Col>
          <Col span={12}>
            <ProFormDigit
              label={intl.formatMessage({
                id: 'pages.lead.fields.deal_size',
                defaultMessage: 'Deal Size',
              })}
              name="order_volume"
            />
          </Col>
        </Row>

        {/* Project Extra Fields */}
        <ExtraFields relatedTo="result" onValuesChange={onProjectExtraFieldValuesChange} />
      </ProForm>
    </InfoCard>
  );
};

export default ProjectForm;
